export const getReservations = async (welletContext, body) => {
  try {
    const result = await welletContext.apis.tickets.post(`/reservation/all`, body);
    return result.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const fetchCities = async (welletContext) => {
  try {
    const result = await welletContext.apis.tickets.get('/shows/cities');
    return result.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const putReservation = async (
  showId,
  paxs,
  customer,
  comments,
  occasion,
  countryCode,
  reservationDateTime,
  totalAmount,
  products,
  lang,
  eventId,
  reservationType,
  description,
  expirationOffset,
  notificationMethod,
  externalRefCode,
  welletContext,
  currency,
  customFields,
  transfers = null,
) => {
  try {
    const body = {
      showId,
      paxs,
      customer,
      customerLanguage: lang,
      comments: comments,
      occasion: occasion,
      countryCode: countryCode,
      reservationDateLocalTime: reservationDateTime,
      totalAmount: totalAmount,
      products: products,
      eventId,
      reservationType,
      expirationOffset,
      notificationMethod,
      externalReferenceCode: externalRefCode,
      description,
      language: null, //It shouldn't be sent, but the API sets it to "ES".
      customerCurrency: currency,
      customFields,
    };
    if (transfers) {
      body.reservationTransferRequest = transfers;
    }

    const result = await welletContext.apis.tickets.put('/reservation/generatereservation', body);
    return result.data;
  } catch (error) {
    console.error(error);
    if (error.response && error.response.data) {
      throw new Error('reservationError.' + error.response.data.errorType);
    } else {
      throw new Error('apiError');
    }
  }
};
export const payReservation = async (
  token,
  card,
  customer,
  amount,
  installments,
  notificationMethod,
  welletContext,
  processingMode,
  deviceId,
) => {
  try {
    const body = {
      token,
      card,
      customer,
      amount,
      installments,
      notificationMethod,
      processingMode,
      deviceId,
    };

    const response = await welletContext.apis.tickets.post(`/reservation/payDeposit`, body);

    return response.data;
  } catch (error) {
    console.error(error);

    if (error.response && error.response.data) {
      throw new Error('paymentError.' + error.response.data.errorType);
    } else {
      throw new Error('apiError');
    }
  }
};

export const getReservation = async (reservationId, welletContext) => {
  try {
    const result = await welletContext.apis.tickets.get(`/reservation/${reservationId}`);
    return result.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const fetchPickups = async (showId, reservationType, welletContext) => {
  try {
    const response = await welletContext.apis.tickets.get(`/transfer/getpickups`, {
      params: { showId, reservationType },
    });

    return response.data;
  } catch (error) {
    console.error(error);

    if (error.response && error.response.data) {
      throw new Error('paymentError.' + error.response.data.errorType);
    } else {
      throw new Error('apiError');
    }
  }
};

export const fetchPickupDetails = async (eventId, fromPickupId, currency, lang, welletContext) => {
  try {
   
//https://rt-api.wellet.dev/transfer/gettransferschedules?eventId=7620&fromPickupId=HOTEL+PENDIENTE+CANC%C3%9AN&currency=USD&lang=en
    const response = await welletContext.apis.tickets.get(`/transfer/gettransferschedules`, {
      params: {
        eventId,
        fromPickupId,
        currency,
        lang,
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);

    if (error.response && error.response.data) {
      throw new Error('paymentError.' + error.response.data.errorType);
    } else {
      throw new Error('apiError');
    }
  }
};

export const validateVoucherCode = async (showId, voucherCode, productIds, welletContext) => {
  try {
    const response = await welletContext.apis.tickets.post(`promotion/ValidateCode`, {
      showId,
      voucherCode,
      productIds,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
export const lockSchedule = async (
  welletContext,
  { pax, reservationDateLocalTime, reservationType, showId, attribute },
) => {
  try {
    const result = await welletContext.apis.tickets.post('/reservation/schedule/lock', {
      pax,
      reservationDateLocalTime,
      reservationType,
      showId,
      attribute,
    });
    return result.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const lockScheduleDelete = async (
  welletContext,
  { reservationDateLocalTime, reservationType, showId, token, paxs, attribute },
) => {
  try {
    const payload = {
      token,
      reservationDateLocalTime,
      reservationType,
      showId,
      paxs,
      attribute,
    };
    const result = await welletContext.apis.tickets.delete('/reservation/schedule/lock', {
      data: payload,
      headers: { 'Content-Type': 'application/json' },
    });
    return result.data;
  } catch (error) {
    console.error(error);

    return null;
  }
};

export const getCategoriesDetails = (welletContext, lang) => {
  try {
    const response = welletContext.apis.tickets.get(`/category/details?lang=${lang}&reservationType=RESTAURANT`);
    return response;
  } catch (error) {
    console.error(error);
  }
};